import { usePropertyContext } from '../context/PropertyContext/usePropertyContext';
export const useObjectTypeId = () => usePropertyContext().objectTypeId;